export const FETCH_LIST_SECURITY_OFFICERS_REQUEST= "FETCH_LIST_SECURITY_OFFICERS_REQUEST";
export const FETCH_LIST_SECURITY_OFFICERS_SUCCESS= "FETCH_LIST_SECURITY_OFFICERS_SUCCESS";
export const FETCH_LIST_SECURITY_OFFICERS_FAILURE= "FETCH_LIST_SECURITY_OFFICERS_FAILURE";

// View single security officer
export const FETCH_SECURITY_OFFICER_REQUEST= "FETCH_SECURITY_OFFICER_REQUEST";
export const FETCH_SECURITY_OFFICER_SUCCESS= "FETCH_SECURITY_OFFICER_SUCCESS";
export const FETCH_SECURITY_OFFICER_FAILURE= "FETCH_SECURITY_OFFICER_FAILURE";

// Add security officer
export const ADD_SECURITY_OFFICER_REQUEST= "ADD_SECURITY_OFFICER_REQUEST";
export const ADD_SECURITY_OFFICER_SUCCESS= "ADD_SECURITY_OFFICER_SUCCESS";
export const ADD_SECURITY_OFFICER_FAILURE= "ADD_SECURITY_OFFICER_FAILURE";

// Edit security officer
export const UPDATE_SECURITY_OFFICER_REQUEST= "UPDATE_SECURITY_OFFICER_REQUEST";
export const UPDATE_SECURITY_OFFICER_SUCCESS= "UPDATE_SECURITY_OFFICER_SUCCESS";
export const UPDATE_SECURITY_OFFICER_FAILURE= "UPDATE_SECURITY_OFFICER_FAILURE";

// Delete security officer
export const DELETE_SECURITY_OFFICER_REQUEST= "DELETE_SECURITY_OFFICER_REQUEST";
export const DELETE_SECURITY_OFFICER_SUCCESS= "DELETE_SECURITY_OFFICER_SUCCESS";
export const DELETE_SECURITY_OFFICER_FAILURE= "DELETE_SECURITY_OFFICER_FAILURE";

// Reset current security officer
export const RESET_CURRENT_SECURITY_OFFICER= "RESET_CURRENT_SECURITY_OFFICER";